// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../conf/Setting";

export function getRoles(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-roles?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getRole(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-role?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function updateRole(owner, uid, role) {
  const newRole = Setting.deepCopy(role);
  return fetch(`${Setting.ServerUrl}/api/update-role?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newRole),
  }).then(res => res.json());
}

export function addRole(role) {
  const newRole = Setting.deepCopy(role);
  return fetch(`${Setting.ServerUrl}/api/add-role`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newRole),
  }).then(res => res.json());
}

export function deleteRole(role) {
  const newRole = Setting.deepCopy(role);
  return fetch(`${Setting.ServerUrl}/api/delete-role`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newRole),
  }).then(res => res.json());
}

export function addRoleUsers(owner, uid, roleName, users) {
  const body = {roleUserInfos: users};
  return fetch(`${Setting.ServerUrl}/api/add-role-users?id=${owner}/${encodeURIComponent(uid)}&roleName=${roleName}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}

export function deleteRoleUsers(owner, uid, users) {
  const body = {roleUserInfos: users};
  return fetch(`${Setting.ServerUrl}/api/del-role-users?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}

export function getRoleApps(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-role-apps?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export async function setRoleApps(owner, uid, roleName, apps) {
  const body = {roleAppInfos: apps};
  return fetch(`${Setting.ServerUrl}/api/set-role-apps?id=${owner}/${encodeURIComponent(uid)}&roleName=${roleName}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}

export function getRoleRules(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-role-rules?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export async function setRoleRules(owner, uid, rules) {
  const body = {roleRules: rules};
  return fetch(`${Setting.ServerUrl}/api/set-role-rules?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}

export function updateRoleUser(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/update-role-user?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

// 获取应用的可访问角色
export function getApplicationRoles(owner, appUid) {
  return fetch(`${Setting.ServerUrl}/api/get-app-roles?id=${owner}/${encodeURIComponent(appUid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

// 设置应用的角色
export async function setApplicationRoles(owner, appUid, roles) {
  const body = {appRoleInfos: roles};
  return fetch(`${Setting.ServerUrl}/api/set-app-roles?id=${owner}/${encodeURIComponent(appUid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}

// 设置用户的角色
export async function setUserRoles(owner, userId, roles) {
  const body = {userRoleInfos: roles};
  return fetch(`${Setting.ServerUrl}/api/set-user-roles?id=${owner}/${encodeURIComponent(userId)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
  }).then(res => res.json());
}
